"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var IFrameRenderer = function IFrameRenderer(_ref) {
  var content = _ref.content,
    title = _ref.title;
  return _react.default.createElement("div", {
    className: "iframeHolder"
  }, _react.default.createElement("iframe", {
    srcDoc: content,
    key: "iframe",
    title: title
  }));
};
var _default = IFrameRenderer;
exports.default = _default;